// Module
var code = "<react-component name=\"MobileAppTestNotifications\"></react-component>\n";
// Exports
module.exports = code;